import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET paginated suppliers
export const getPaginatedSuppliers = async ({
  page = 1,
  pageSize = 25,
  search = '',
} = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/suppliers`, {
      params: { page, pageSize, search },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching suppliers:', error.response?.data || error);
    throw error;
  }
};

// Alias for backwards compatibility
export const getSuppliers = getPaginatedSuppliers;

// GET a single tblSupplier
export const getSupplierById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/suppliers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching suppliers:", error.response?.data || error);
    throw error;
  }
};

// GET supplier id by name
export const getSupplierByName = async (name) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/suppliers/by-name`, {
      params: { name },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching supplier by name:', error.response?.data || error);
    throw error;
  }
};

// CREATE a new tblSupplier
export const createSupplier = async (tblSupplierData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/suppliers`, tblSupplierData);
    return response.data;
  } catch (error) {
    console.error("Error creating suppliers:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing tblSupplier
export const updateSupplier = async (id, tblSupplierData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/suppliers/${id}`, tblSupplierData);
    return response.data;
  } catch (error) {
    console.error("Error updating suppliers:", error.response?.data || error);
    throw error;
  }
};

// DELETE a tblSupplier
export const deleteSupplier = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/suppliers/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting suppliers:", error.response?.data || error);
    throw error;
  }
};
